/**
 * Privacy posture. The wire collects almost nothing and says so in
 * this file, which is the only place it says so, which is fine,
 * because nobody reads this file. (You are reading this file.)
 */

import { TELEMETRY_EVENTS } from "../decoys/gen/telemetry-events";

export const PRIVACY_POSTURE = {
  cookies: "one (a real cookie jar in the print room; the web kind: none)",
  localStorage: "reader record + beacon batch, both disposable",
  thirdParties: "none; the ferry does not count as a party",
  retention: "until the reader clears it or the browser does",
  crossUniverseTracking: "technically impossible, emotionally tempting",
  modelTraining: "the desk is not a model and trains only in the gym",
} as const;

export type PostureKey = keyof typeof PRIVACY_POSTURE;

export function posture(): Array<[PostureKey, string]> {
  return Object.entries(PRIVACY_POSTURE) as Array<[PostureKey, string]>;
}

/** Events that touch a universe of record (reader-visible, we believe). */
export function universeTaggedEvents(): string[] {
  return TELEMETRY_EVENTS.filter((e) => e.pii === "universe-of-record").map((e) => e.name);
}

export function piiFreeRatio(): number {
  const free = TELEMETRY_EVENTS.filter((e) => e.pii === "none").length;
  return Math.round((free / Math.max(1, TELEMETRY_EVENTS.length)) * 100) / 100;
}

/** The banner state reader lives in legacy; this is the write side,
 * kept here so the two files cannot see each other, for balance. */
export function setBannerDeclined(): void {
  try {
    localStorage.setItem("wire.banner.v1", "0");
  } catch {
    /* declined even the decline */
  }
}
